import axios from "axios";
import {SERVER_URL} from "../../config";
import {authHeader, contentTypeHeader} from "_helpers";

function get(id) {
    const endpoint = `${SERVER_URL}/api/v1/invites/${id}`;
    return axios.get(endpoint,{
        headers: authHeader()
    })
}

function list(params) {
    const endpoint = `${SERVER_URL}/api/v1/invites/list`;
    return axios.get(endpoint,{
        params: params,
        headers: authHeader()
    })
}

function accept(payload) {
    const endpoint = `${SERVER_URL}/api/v1/invites/accept`;
    return axios.post(endpoint, payload, {
        headers: contentTypeHeader()
    })
}

function revoke(id) {
    const endpoint = `${SERVER_URL}/api/v1/invites/${id}/revoke`;
    return axios.post(endpoint, {},{
        headers: authHeader()
    })
}

function unrevoke(id) {
    const endpoint = `${SERVER_URL}/api/v1/invites/${id}/unrevoke`;
    return axios.post(endpoint, {}, {
        headers: authHeader()
    })
}

function resend(id, payload) {
    const endpoint = `${SERVER_URL}/api/v1/invites/${id}/resend`;
    return axios.post(endpoint, payload, {
        headers: authHeader()
    })
}

function create(payload) {
    const endpoint = `${SERVER_URL}/api/v1/invites/create`;
    return axios.post(endpoint, payload, {
        headers: authHeader()
    })
}

function passwordStatus() {
    const endpoint = `${SERVER_URL}/api/v1/invites/password-status`;
    return axios.get(endpoint,{
        headers: authHeader()
    })
}

function createPassword(payload) {
    const endpoint = `${SERVER_URL}/api/v1/invites/password`;
    return axios.post(endpoint, payload, {
        headers: authHeader()
    })
}

export const userInviteService = {
    get,
    list,
    accept,
    revoke,
    unrevoke,
    resend,
    create,
    passwordStatus,
    createPassword
};